import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetOrdersFilterLimits } from "./getOrdersFilterLimits.request";
import { GetOrdersFilterLimitsResponse } from "./getOrdersFilterLimits.types";

const useGetOrdersFilterLimits = (
  options?: QueryOptions<
    GetOrdersFilterLimitsResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", "admin", "calculate-with-order-statistics"],
    queryFn: requestGetOrdersFilterLimits,
    onError: toastServerError,
    ...options
  });

  return { filterLimits: data, ...rest };
};

export default useGetOrdersFilterLimits;
